export default __webpack_public_path__ + "static/media/SIFA_NL_SEQ09.ad01557d.mp3";